<template lang="pug">
#layout-base
  b-navbar#header.d-print-none(ref="header" variant="info" sticky=true)
    .hedaer-content.d-flex.justify-content-start.align-items-center.flex-wrap
      .flex-grow-1.d-flex.justify-content-start.align-items-center
        b-navbar-brand.d-flex.justify-content-start.align-items-center
          span.title.mr-2 HitomeQコネクト 管理システム
          .facility-name.mr-2
            span {{ _facilityName }}
          button.btn.facility-change-btn(v-if="_showFacilityChangeButton" @click="showFacilitySelectModal") 切替

      b-navbar-nav
        b-nav-text.today(v-show="showToday")
          span.unit {{ today.year }}年
          span.value {{ today.month }}
          span.unit 月
          span.value {{ today.date }}
          span.unit 日
        b-nav-text.user-name
          b-dropdown(:text="name" variant="transparent")
            b-dropdown-item(:to="urls.AccountEdit" @click.native="refreshBadge") ユーザー情報修正
            b-dropdown-item(:to="urls.ManualList" @click.native="refreshBadge") マニュアル
            b-dropdown-item(:to="urls.About" @click.native="refreshBadge") HitomeQコネクトについて
            b-dropdown-divider
            b-dropdown-item(@click="conformLogout" ref="logout") ログアウト
        b-nav-text.d-flex.buttons
          //- goto Support
          #support-btn.support
            router-link(:to="urls.SupportList" @click.native="refreshBadge")
              button.btn(type="button")
                .menu-icon.support-icon
                .header-badge
                  b-badge(v-if="nonFinishedContactCount" pill variant="sidemenu-badge") {{ nonFinishedContactCount }}
          b-popover(target="support-btn" placement="bottomleft" triggers="hover") お問い合わせ

          //- goto Notification
          #notification-btn.information
            router-link(:to="urls.NotificationList" @click.native="refreshBadge")
              button.btn(type="button")
                .menu-icon.information-icon
                .header-badge
                  b-badge(v-if="unconfirmedNotificationCount" pill variant="sidemenu-badge") {{ unconfirmedNotificationCount }}
          b-popover(target="notification-btn" placement="bottomleft" triggers="hover") お知らせ

          //- managements
          #management-btn.management(
            v-if="(useFunction('residentsFunction') || useFunction('familiesFunction') || useFunction('otherUserGroupsFunction')) && _useFamilyService"
            :class="{ 'router-active': _isManagementActive }")
            b-dropdown(@show="showManagementPopover" @hide="hideManagementPopover" right)
              template(v-slot:button-content)
                .menu-icon.management-icon
              b-dropdown-item(v-if="useFunction('residentsFunction')" :to="urls.ResidentList" @click.native="refreshBadge") 利用者
              b-dropdown-item(v-if="useFunction('familiesFunction')" :to="urls.FamilyList" @click.native="refreshBadge") 家族ユーザー
              b-dropdown-item(v-if="_isOverBasicPlan && useFunction('otherUserGroupsFunction')"
                :to="urls.OtherUserGroupList" @click.native="refreshBadge") 施設関係者
              b-dropdown-item#disable-otheruser.disable(v-else-if="!_isOverBasicPlan") 施設関係者
              b-dropdown-item(v-if="_isOverLightPlan" :to="urls.SendMessageGroupList" @click.native="refreshBadge") 宛先グループ
              b-dropdown-item#disable-send-message-groups.disable(v-else-if="!_isOverLightPlan") 宛先グループ
          b-popover(v-if="!_isOverBasicPlan && _useFamilyService" target="disable-otheruser" triggers="hover" placement="top")
            span ベーシックプラン以上で使用可能
          b-popover(v-if="!_isOverLightPlan && _useFamilyService" target="disable-send-message-groups" triggers="hover" placement="top")
            span ライトプラン以上で使用可能
          b-popover(
            v-if="(useFunction('residentsFunction') || useFunction('familiesFunction') || useFunction('otherUserGroupsFunction')) && _useFamilyService"
            ref="managementPopover" target="management-btn" placement="bottomleft" triggers="hover")
            span 利用者等管理

          //- settings
          #setting-btn.facility(:class="{ 'router-active': _isSettingActive }")
            b-dropdown(@show="showSettingPopover" @hide="hideSettingPopover" right)
              template(v-slot:button-content)
                .menu-icon.setting-icon
              //- edit facility
              b-dropdown-item(v-if="_useFamilyService || _useWaiterService" :to="urls.Facility" @click.native="refreshBadge") 施設情報
              //- edit rooms
              b-dropdown-item(v-if="_useFamilyService" :to="urls.RoomList" @click.native="refreshBadge") 部屋情報
              b-dropdown-divider(v-if="_useFamilyService")

              //- edit functions
              b-dropdown-item(v-if="_useFamilyService" :to="urls.PermittedFunctionList" @click.native="refreshBadge") 家族の使用機能

              //- edit family permitted functions
              b-dropdown-item(v-if="_isOverLightPlan && _useFamilyService && useFunction('individuallyUseFamilyFunctionsFunction')"
                :to="urls.FamilyPermittedFunctionList" @click.native="refreshBadge") 家族の使用機能（個別設定）
              b-dropdown-item.disable(v-else-if="!_isOverLightPlan && _useFamilyService" title="ライトプラン以上で使用可能") 家族の使用機能（個別設定）
              b-dropdown-divider(v-if="_isAdminRole && _useFamilyService")

              //- edit other user permitted functions
              b-dropdown-item(v-if="_isOverBasicPlan && _useFamilyService"
                :to="urls.OtherUserPermittedFunctionList" @click.native="refreshBadge") 施設関係者の使用機能
              b-dropdown-divider(v-if="_isOverBasicPlan && _useFamilyService")

              //- manage notifications
              b-dropdown-item(v-if="_isAdminRole && _showNotificationSetting"
                :to="urls.NotificationSettingEdit" @click.native="refreshBadge") 通知設定
              b-dropdown-item.disable(v-else-if="!_isOverLightPlan && _useFamilyService" title="ライトプラン以上で使用可能") 通知設定

              //- manage standard users(family and waiter service)
              template(v-if="_useFamilyService && _useWaiterService")
                b-dropdown-item(v-if="_isAdminRole && (_isOverLightPlan || _isOverWaiterBasicPlan)"
                  :to="urls.StandardAccountList" @click.native="refreshBadge") 一般ユーザー管理
                b-dropdown-item.disable(v-else-if="!_isOverLightPlan && !_isOverWaiterBasicPlan" title="家族連絡サービスライトプラン以上または入所者募集管理サービスのベーシックプラン以上で使用可能") 一般ユーザー管理
              //- manage standard users(family service)
              template(v-else-if="_useFamilyService")
                b-dropdown-item(v-if="_isAdminRole && _isOverLightPlan"
                  :to="urls.StandardAccountList" @click.native="refreshBadge") 一般ユーザー管理
                b-dropdown-item.disable(v-else-if="!_isOverLightPlan" title="ライトプラン以上で使用可能") 一般ユーザー管理
              //- manage standard users(waiter service)
              template(v-else-if="_useWaiterService")
                b-dropdown-item(v-if="_isAdminRole && _isOverWaiterBasicPlan"
                  :to="urls.StandardAccountList" @click.native="refreshBadge") 一般ユーザー管理
                b-dropdown-item.disable(v-else-if="!_isOverWaiterBasicPlan" title="ライトプラン以上で使用可能") 一般ユーザー管理
              b-dropdown-divider(v-if="_isAdminRole && (_useFamilyService || _useWaiterService)")

              //- cooperation system list
              b-dropdown-item(:to="urls.CooperationSystemList" @click.native="refreshBadge") システム連携

              //- edit plan
              b-dropdown-item(v-if="_isAdminRole" :to="urls.Plan" @click.native="refreshBadge") 契約プラン

              //- do terminate
              b-dropdown-item(v-if="_isAdminRole" :to="urls.Terminate" @click.native="refreshBadge") 解約のお手続き
          b-popover(ref="settingPopover" target="setting-btn" placement="bottomleft" triggers="hover") 各種設定

  //- sidebar
  b-sidebar#sidebar.d-print-none(v-model="aleadySidebar" :sidebar-class="_getSidebarClass" :width="sidebarWidth" bg-variant="sidemenu" no-header no-close-on-route-change)
    //- ヘッダーメニューの高さ変更に応じた余白
    .sidebar-margin(:style="{ 'margin-top': _sidebarMarginTop }")
    //- サービスメニュー切替え
    .toggle-menu(v-if="_showToggleSideMenu")
      a(@click="toggleSideMenu" title="クリックでサービスメニューを切り替え")
        i.menu-icon.toggle-menu-icon
        transition(name="service-title")
          span.tab-text(v-if="_curerntSideMenu == 'familyService'") 家族連絡
          span.tab-text(v-else-if="_curerntSideMenu == 'waiterService'") 入所者募集管理
          span.tab-text(v-else-if="_curerntSideMenu == 'otherOfficeService'") 他事業所連携

    //- 家族連絡サービスサイドメニュー
    transition(name="service-menu")
      .main-menus.family-service-menu(v-if="_curerntSideMenu == 'familyService' && _useFamilyService")
        //- トップ
        .menu-tab
          router-link(:to="urls.HomeForFamilies" @click.native="refreshBadge")
            i.menu-icon.home-icon
            span.tab-text(v-show="showSidebar") トップ
        .separator

        //- メッセージ送信
        .menu-tab(v-if="useFunction('sendMessagesFunction')")
          router-link(:to="urls.SendMessage" @click.native="refreshBadge")
            i.menu-icon.sendmessage-icon
            .sidemenu-badge
              .mt-2
              b-badge(v-if="showSendMessageIncoming" pill variant="sidemenu-badge")
                .sidemenu-badge-content
            span.tab-text(v-show="showSidebar") メッセージ送信
        //- 文書送付
        .menu-tab(v-if="_isBasicPlan")
          template(v-if="useFunction('sendDocumentsFunction')")
            router-link(:to="urls.SendDocumentList" @click.native="refreshBadge")
              i.menu-icon.senddocument-icon
              span.tab-text(v-show="showSidebar") 文書送付
        .menu-tab(v-else)
          a.translucent(title="ベーシックプランで使用可能")
            i.menu-icon.senddocument-icon.translucent
            span.tab-text(v-show="showSidebar") 文書送付
        //- 受信メッセージ
        .menu-tab(v-if="showOpinionMessageMenu() && useFunction('receiveMessagesFunction')")
          router-link(:to="urls.ReceiveMessageList" @click.native="refreshBadge")
            i.menu-icon.receive-message-icon
            .sidemenu-badge
              b-badge(v-if="nonFinishedOpinionCount" pill variant="sidemenu-badge") {{ nonFinishedOpinionCount }}
            span.tab-text(v-show="showSidebar") 受信メッセージ
        .separator

        //- 面会予約
        .menu-tab(v-if="(showMenuOfPermitted('reservation') || showMenuOfPermitted('onlineReservation')) && useFunction('reservationsFunction')")
          router-link(:to="urls.ReservationList" @click.native="refreshBadge")
            i.menu-icon.reservation-icon
            .sidemenu-badge
              b-badge(v-if="unconsentedReservationCount" pill variant="sidemenu-badge") {{ unconsentedReservationCount }}
            span.tab-text(v-show="showSidebar") 面会予約
        //- 外出外泊届け
        .menu-tab(v-if="_isOverLightPlan")
          template(v-if="showMenuOfPermitted('outing') && useFunction('outingsFunction')")
            router-link(:to="urls.OutingList" @click.native="refreshBadge")
              i.menu-icon.outing-icon
              .sidemenu-badge
                b-badge(v-if="unconsentedOutingCount" pill variant="sidemenu-badge") {{ unconsentedOutingCount }}
              span.tab-text(v-show="showSidebar") 外出外泊届け
        .menu-tab(v-else)
          a.translucent(title="ライトプラン以上で使用可能")
            i.menu-icon.outing-icon.translucent
            span.tab-text(v-show="showSidebar") 外出外泊届け
        //- イベント情報
        .menu-tab(v-if="_isOverBasicPlan")
          template(v-if="showMenuOfPermitted('event') && useFunction('eventsFunction')")
            router-link(:to="urls.EventList" @click.native="refreshBadge")
              i.menu-icon.event-icon
              span.tab-text(v-show="showSidebar") イベント情報
        .menu-tab(v-else)
          a.translucent(title="ベーシックプラン以上で使用可能")
            i.menu-icon.event-icon.translucent
            span.tab-text(v-show="showSidebar") イベント情報
        //- 写真印刷依頼
        .menu-tab(v-if="_isOverBasicPlan")
          template(v-if="showMenuOfPermitted('picture') && useFunction('picturesFunction')")
            router-link(:to="urls.PictureList" @click.native="refreshBadge")
              i.menu-icon.picture-icon
              .sidemenu-badge
                b-badge(v-if="nonDistributedCount" pill variant="sidemenu-badge") {{ nonDistributedCount }}
              span.tab-text(v-show="showSidebar") 写真印刷依頼
        .menu-tab(v-else)
          a.translucent(title="ベーシックプラン以上で使用可能")
            i.menu-icon.picture-icon.translucent
            span.tab-text(v-show="showSidebar") 写真印刷依頼
        //- 介護記録
        .menu-tab(v-if="_isOverBasicPlan")
          template(v-if="showMenuOfPermitted('careimage') && useFunction('careimagesFunction')")
            router-link(:to="urls.CareimageList" @click.native="refreshBadge")
              i.menu-icon.careimage-icon
              span.tab-text(v-show="showSidebar") 介護記録
        .menu-tab(v-else)
          a.translucent(title="ベーシックプラン以上で使用可能")
            i.menu-icon.careimage-icon.translucent
            span.tab-text(v-show="showSidebar") 介護記録
        .separator

        //- 空床スケジュール
        .menu-tab(v-if="_isBasicPlan")
          template(v-if="useFunction('roomSchedulesFunction')")
            router-link(:to="urls.RoomScheduleList" @click.native="refreshBadge")
              i.menu-icon.room-schedule-icon
              span.tab-text(v-show="showSidebar") 空床スケジュール
        .menu-tab(v-else)
          a.translucent(title="ベーシックプランで使用可能")
            i.menu-icon.room-schedule-icon.translucent
            span.tab-text(v-show="showSidebar") 空床スケジュール
        //- アンケート
        .menu-tab(v-if="_isBasicPlan")
          template(v-if="useFunction('questionnairesFunction')")
            router-link(:to="urls.QuestionnaireList" @click.native="refreshBadge")
              i.menu-icon.questionnaires-icon
              span.tab-text(v-show="showSidebar") アンケート
        .menu-tab(v-else)
          a.translucent(title="ベーシックプランで使用可能")
            i.menu-icon.questionnaires-icon.translucent
            span.tab-text(v-show="showSidebar") アンケート
        //- 安否確認
        .menu-tab(v-if="_isBasicPlan")
          template(v-if="useFunction('safetyConfirmationFunction')")
            router-link(:to="urls.SafetyConfirmList" @click.native="refreshBadge")
              i.menu-icon.safetyconfirm-icon
              span.tab-text(v-show="showSidebar") 安否確認
        .menu-tab(v-else)
          a.translucent(title="ベーシックプランで使用可能")
            i.menu-icon.safetyconfirm-icon.translucent
            span.tab-text(v-show="showSidebar") 安否確認
        .separator

        //- 家族の使用状況
        .menu-tab(v-if="useFunction('familyMessagesFunction')")
          router-link(:to="urls.FamilyMessageList" @click.native="refreshBadge")
            i.menu-icon.messagelist-icon
            span.tab-text(v-show="showSidebar") 家族の使用状況
        //- カレンダー・履歴
        .menu-tab(v-if="_isOverLightPlan")
          template(v-if="useFunction('reportsFunction')")
            router-link(:to="urls.Report" @click.native="refreshBadge")
              i.menu-icon.report-icon
              span.tab-text(v-show="showSidebar") カレンダー・履歴
        .menu-tab(v-else)
          template
            a.translucent(title="ライトプラン以上で使用可能")
              i.menu-icon.report-icon.translucent
              span.tab-text(v-show="showSidebar") カレンダー・履歴

    //- 待機者管理サービスサイドメニュー
    transition(name="service-menu")
      .main-menus.waiter-service-menu(v-show="_curerntSideMenu == 'waiterService' && _useWaiterService")
        //- トップ
        .menu-tab
          router-link(:to="urls.HomeForWaiters" @click.native="refreshBadge")
            i.menu-icon.home-icon
            span.tab-text(v-show="showSidebar") トップ
        .separator

        //- 入所申込者管理
        .menu-tab(v-if="useFunction('waitersFunction')")
          router-link(:to="urls.WaiterList" @click.native="refreshBadge")
            i.menu-icon.waiter-icon
            .sidemenu-badge
              .mt-2
              b-badge(v-if="beforeJudgementWaiterCount" pill variant="sidemenu-badge") {{ beforeJudgementWaiterCount }}
            span.tab-text(v-show="showSidebar") 入所申込者管理
        //- 待機者メッセージ送信
        .menu-tab(v-if="_isOverWaiterBasicPlan")
          template(v-if="useFunction('waiterSendMessagesFunction')")
            router-link(:to="urls.WaiterSendMessage" @click.native="refreshBadge")
              i.menu-icon.waiter-sendmessage-icon
              .sidemenu-badge
                .mt-2
                b-badge(v-if="showWaiterSendMessageIncoming" pill variant="sidemenu-badge")
                  .sidemenu-badge-content
              span.tab-text(v-show="showSidebar") メッセージ送信
        .menu-tab(v-else)
          a.translucent(title="ベーシックプラン以上で使用可能")
            i.menu-icon.waiter-sendmessage-icon.translucent
            span.tab-text(v-show="showSidebar") メッセージ送信
        //- 受信メッセージ
        .menu-tab(v-if="_isOverWaiterBasicPlan")
          template(v-if="useFunction('waiterReceiveMessagesFunction')")
            router-link(:to="urls.WaiterReceiveMessageList" @click.native="refreshBadge")
              i.menu-icon.receive-message-icon
              .sidemenu-badge
                b-badge(v-if="nonFinishedWaiterOpinionCount" pill variant="sidemenu-badge") {{ nonFinishedWaiterOpinionCount }}
              span.tab-text(v-show="showSidebar") 受信メッセージ
        .menu-tab(v-else)
          a.translucent(title="ベーシックプラン以上で使用可能")
            i.menu-icon.receive-message-icon.translucent
            span.tab-text(v-show="showSidebar") 受信メッセージ
        //- フォロワー
        .menu-tab(v-if="_isOverWaiterBasicPlan")
          template(v-if="useFunction('waiterFollowersFunction')")
            router-link(:to="urls.FollowerList" @click.native="refreshBadge")
              i.menu-icon.follower-icon
              span.tab-text(v-show="showSidebar") フォロワー
        .menu-tab(v-else)
          a.translucent(title="ベーシックプラン以上で使用可能")
            i.menu-icon.follower-icon.translucent
            span.tab-text(v-show="showSidebar") フォロワー
        //- 施設見学
        .menu-tab(v-if="useFunction('inspectionReservationsFunction')")
          router-link(:to="urls.InspectionReservationList" @click.native="refreshBadge")
            i.menu-icon.inspection-reservation-icon
            .sidemenu-badge
              .mt-2
              b-badge(v-if="showInspectionReservationCount" pill variant="sidemenu-badge") {{ showInspectionReservationCount }}
            span.tab-text(v-show="showSidebar") 施設見学
        //- お問い合わせ
        .menu-tab(v-if="useFunction('recruitmentContactsFunction')")
          router-link(:to="urls.RecruitmentContactList" @click.native="refreshBadge")
            i.menu-icon.recruitment-contact-icon
            .sidemenu-badge
              .mt-2
              b-badge(v-if="showRecruitmentContactCount" pill variant="sidemenu-badge") {{ showRecruitmentContactCount }}
            span.tab-text(v-show="showSidebar") お問い合わせ
        .separator

        //- カレンダー・履歴
        .menu-tab(v-if="_isOverWaiterBasicPlan")
          template(v-if="useFunction('reportsFunction')")
            router-link(:to="urls.Report" @click.native="refreshBadge")
              i.menu-icon.report-icon
              span.tab-text(v-show="showSidebar") カレンダー・履歴
        .menu-tab(v-else)
          template
            a.translucent(title="ベーシックプラン以上で使用可能")
              i.menu-icon.report-icon.translucent
              span.tab-text(v-show="showSidebar") カレンダー・履歴

    //- 他事業所連携サービスサイドメニュー
    transition(name="service-menu")
      .main-menus.other-office-service-menu(v-if="_curerntSideMenu == 'otherOfficeService' && _useOtherOfficeService")
        //- トップ
        .menu-tab
          router-link(:to="urls.HomeForOtherOffice" @click.native="refreshBadge")
            i.menu-icon.home-icon
            span.tab-text(v-show="showSidebar") トップ
        .separator
        //- メッセージ
        .menu-tab(v-if="useFunction('otherOfficeMessagesFunction')")
          router-link(:to="urls.OtherOfficeMessages" @click.native="refreshBadge")
            i.menu-icon.sendmessage-icon
            .sidemenu-badge
              .mt-2
              b-badge(v-if="showSendOtherOfficeMessageIncoming" pill variant="sidemenu-badge")
                .sidemenu-badge-content
            span.tab-text(v-show="showSidebar") メッセージ
        //- オンライン会議
        .menu-tab(v-if="useFunction('otherOfficeOnlineMeetingsFunction')")
          router-link(:to="urls.OtherOfficeOnlineMeetings" @click.native="refreshBadge")
            i.menu-icon.online-meeting-icon
            span.tab-text(v-show="showSidebar") オンライン会議
        //- 空床情報
        .menu-tab(v-if="useFunction('otherOfficeRoomSchedulesFunction')")
          router-link(:to="urls.OtherOfficeRoomSchedules" @click.native="refreshBadge")
            i.menu-icon.room-schedule-icon
            .sidemenu-badge
              b-badge(v-if="0 < noreplyOtherOfficeAcceptanceRequestCount" pill variant="sidemenu-badge") {{ noreplyOtherOfficeAcceptanceRequestCount }}
            span.tab-text(v-show="showSidebar") 空床情報

        //- カレンダー・履歴
        .menu-tab
          template(v-if="useFunction('reportsFunction')")
            router-link(:to="urls.Report" @click.native="refreshBadge")
              i.menu-icon.report-icon
              span.tab-text(v-show="showSidebar") カレンダー・履歴

    template(#footer)
      .menu-tab(v-if="showSidebar")
        a.hide-menu(@click="showSidebar = !showSidebar; sidebarWidth='50px'")
          i.menu-icon.hide-menu-icon
          span.tab-text(v-show="showSidebar") メニューを隠す
      .menu-tab(v-if="!showSidebar")
        a.show-menu(@click="showSidebar = !showSidebar; sidebarWidth='210px'")
          i.menu-icon.show-menu-icon

  //- main content
  #content(v-if="showContent" :class="_sidebarMargin")
    keep-alive(:include="cacheTargetComponentNames")
      router-view.main-content.container-fluid(@refresh="refreshBadge")

  //- facility select
  FacilitySelectModal(v-model="showFacilitySelect" :facilityId.sync="selectFacilityId" :facilityOptions="facilityOptions"
    @ok="onLoginByFacility" @cancel="selectFacilityId = null;")
  //- loading
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  //- logout modal component
  LogoutModal(id="logout-modal" ref="logout")
  //- ad modal component
  PaidPlanAdsModal(v-model="showAdModal" @ok="closeAdModal")
  //- remind modal component
  RemindReservatoinModal(v-model="showRemindReservatoinModal" :reservations="remindReservation" :isLoading="remindReservationIsLoading"
    :visitSetting="visitSetting" :onlineSetting="onlineSetting"
    @ok="closeRemindReservatoinModal" @print="printRemindReservations")
  //- remind modal component
  RemindOutingModal(v-model="showRemindOutingModal" :outings="remindOuting" :isLoading="remindOutingIsLoading"
    @ok="closeRemindOutingModal" @print="printRemindOutings")
  //- notification terminate
  NotificationTerminateModal(v-model="showNotificationTerminateModal")
  //- notification modal component
  UnReadNotificationsModal(v-model="showUnReadNotificationsModal" :notifications="unReadNotifications")

  //- login error modal component
  OkModal(v-model="showLoginErrorModal" title="ログインエラー" :message="loginErrorMessage" messageStyle="color:rgba(217, 74, 125, 1);")
</template>

<script lang="ts">
import { Component, Inject, Watch, Ref, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AxiosError } from "axios";

import { userStore, fontsStore, editAccountStore, itemListFilterStore, screenInputTemporaryStore } from "@/store/store";
import { tabIndexesStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";
import { Url } from "@/commons/constants/Url";
import { RemindReservationsPdf as RemindReservationsPdfUtil } from "@/commons/utils/RemindReservationsPdf";
import { RemindOutingsPdf as RemindOutingsPdfUtil } from "@/commons/utils/RemindOutingsPdf";

import AuthorizationService, { LoginByFacilityPostModel, LoginByFacilityResponse } from "@/commons/services/Authorization";
import { PermittedFunctions } from "@/commons/services/Facilities";
import PicturesService from "@/commons/services/Pictures";
import OpinionsService from "@/commons/services/Opinions";
import OtherUserOpinionsService from "@/commons/services/OtherUserOpinions";
import ContactsService from "@/commons/services/Contacts";
import AccountsService from "@/commons/services/Accounts";
import ReservationsService, { ReservationsGetModel } from "@/commons/services/Reservations";
import ReservationSettingsService, { ReservationSettingsGetModel } from "@/commons/services/ReservationSettings";
import OnlineReservationSettingsService, { OnlineReservationSettingsGetModel } from "@/commons/services/OnlineReservationSettings";
import SendMessageRepliesService, { SendMessageRepliesUnreadModel } from "@/commons/services/SendMessageReplies";
import WaiterSendMessageRepliesService, { WaiterSendMessageRepliesUnreadModel } from "@/commons/services/WaiterSendMessageReplies";
import OtherUserGroupSendMessageRepliesService from "@/commons/services/OtherUserGroupSendMessageReplies";
import WaitersService, { WaitersGetModel } from "@/commons/services/Waiters";
import InspectionReservationsService, { InspectionReservationsGetModel } from "@/commons/services/InspectionReservations";
import RecruitmentContactsService, { RecruitmentContactsGetModel } from "@/commons/services/RecruitmentContacts";
import WaiterOpinionsService from "@/commons/services/WaiterOpinions";
import OutingsService, { OutingGetModel } from "@/commons/services/Outings";
import OtherOfficeAcceptanceRequestsService from "@/commons/services/OtherOfficeAcceptanceRequests";

import SystemError, { HitomeqErrorType } from "@/commons/models/SystemError";
import { Role } from "@/commons/services/Authorization";
import { PlanType } from "@/commons/services/Plans";
import NotificationsService, { NotificationsGetModel } from "@/commons/services/Notifications";
import { UnReadNotificationTableItem } from "@/pc/containers/notifications/UnReadNotificationTable.vue";
import UnReadNotificationsModal from "@/pc/components/modals/UnReadNotificationsModal.vue";
import PaidPlanAdsModal from "@/pc/components/modals/PaidPlanAdsModal.vue";
import RemindReservatoinModal from "@/pc/components/modals/RemindReservatoinModal.vue";
import RemindOutingModal from "@/pc/components/modals/RemindOutingModal.vue";
import NotificationTerminateModal from "@/pc/components/modals/NotificationTerminateModal.vue";
import LogoutModal from "@/pc/components/modals/LogoutModal.vue";
import { WaiterServicePlanType } from "@/commons/services/WaiterServicePlans";
import { ResidentStatus } from "@/commons/services/Residents";
import FacilitySelectModal from "@/pc/basics/FacilitySelectModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import OkModal from "../basics/OkModal.vue";

/**
 * 基底レイアウトコンポーネント
 *
 * ヘッダー、サイドバーの機能を提供する
 * 共通コンポーネントも本コンポーネントで読込み、各画面にemmit経由で提供する
 * 本コンポーネントに共通する機能を何でもかんでも詰め込まないように注意すること
 * base(基底)であって、common(共通)という責務ではないことを意識すること
 */
@Component({
  components: {
    PaidPlanAdsModal,
    UnReadNotificationsModal,
    RemindReservatoinModal,
    RemindOutingModal,
    LogoutModal,
    FacilitySelectModal,
    NotificationTerminateModal,
    PageLoading,
    OkModal
  }
})
export default class LayoutDefault extends Vue {
  /** ログインサービス */
  @Inject("AuthorizationService") authorizationService!: AuthorizationService;
  /** 写真サービス */
  @Inject("PicturesService") picturesService!: PicturesService;
  /** 意見サービス */
  @Inject("OpinionsService") opinionsService!: OpinionsService;
  /** 意見サービス */
  @Inject("OtherUserOpinionsService") otherUserOpinionService!: OtherUserOpinionsService;
  /** 問い合わせサービス */
  @Inject("ContactsService") contactsService!: ContactsService;
  /** アカウントサービス */
  @Inject("AccountsService") accountsService!: AccountsService;
  /** メッセージ送信の返信サービス */
  @Inject("SendMessageRepliesService") sendMessageRepliesService!: SendMessageRepliesService;
  /** メッセージ送信の返信サービス */
  @Inject("WaiterSendMessageRepliesService") waiterSendMessageRepliesService!: WaiterSendMessageRepliesService;
  /** メッセージ送信の返信サービス */
  @Inject("OtherUserGroupSendMessageRepliesService") otherUserGroupSendMessageRepliesService!: OtherUserGroupSendMessageRepliesService;
  /** 面会予約サービス */
  @Inject("ReservationsService") reservationsService!: ReservationsService;
  /** 訪問面会設定サービス */
  @Inject("ReservationSettingsService") reservationSettingsService!: ReservationSettingsService;
  /** オンライン面会設定サービス */
  @Inject("OnlineReservationSettingsService") onlineReservationSettingsService!: OnlineReservationSettingsService;
  /** お知らせサービス */
  @Inject("NotificationsService") notificationsService!: NotificationsService;
  /** 待機者サービス */
  @Inject("WaitersService") waitersService!: WaitersService;
  /** 施設見学サービス */
  @Inject("InspectionReservationsService") inspectionReservationsService!: InspectionReservationsService;
  /** 入所募集問い合わせサービス */
  @Inject("RecruitmentContactsService") recruitmentContactsService!: RecruitmentContactsService;
  /** 意見サービス(待機者) */
  @Inject("WaiterOpinionsService") waiterOpinionsService!: WaiterOpinionsService;
  /** 外出外泊届けサービス */
  @Inject("OutingsService") outingsService!: OutingsService;
  /** 受入 リクエストサービス */
  @Inject("OtherOfficeAcceptanceRequestsService") otherOfficeAcceptanceRequestsService!: OtherOfficeAcceptanceRequestsService;

  @Ref()
  header!: Vue;

  /** ユーザー名。ユーザー情報修正画面で更新されるので、storeのgetterから値を取得する */
  @Getter("userName") public name!: string;

  /** コンテンツエリアの表示可否、施設切り替えタイミングでkeep-aliveのキャッシュクリアに使用する */
  showContent: boolean = true;

  /** ログイン先施設切り替えモーダル用施設ID */
  selectFacilityId: number | null = null;
  /** 施設選択モーダル選択肢 */
  facilityOptions: Array<{ value: number | string; label: string }> = [];
  /** 施設選択モーダル（PC）表示可否 */
  showFacilitySelect: boolean = false;
  /** ログインエラーモーダル表示可否 */
  showLoginErrorModal: boolean = false;
  /** ログインエラーメッセージ */
  loginErrorMessage: string = "";

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 有料プラン広告モーダルの表示可否 */
  showAdModal: boolean = false;
  /** 面会予約リマインドの表示可否 */
  showRemindReservatoinModal: boolean = false;
  /** 面会予約リマインド */
  remindReservation: Array<ReservationsGetModel> = [];
  /** 面会予約リマインド読み込み中か否か */
  remindReservationIsLoading: boolean = true;
  /** 訪問面会設定 */
  visitSetting: ReservationSettingsGetModel | null = null;
  /** オンライン面会設定 */
  onlineSetting: OnlineReservationSettingsGetModel | null = null;

  /** 外出外泊届けリマインドの表示可否 */
  showRemindOutingModal: boolean = false;
  /** 外出外泊届けリマインド */
  remindOuting: Array<OutingGetModel> = [];
  /** 外出外泊届けリマインド読み込み中か否か */
  remindOutingIsLoading: boolean = true;
  /** 解約依頼中の場合の通知モーダル */
  showNotificationTerminateModal: boolean = false;

  /** サイドバーは常に表示するので固定値 */
  aleadySidebar: boolean = true;
  /** サイドバーメニュー部の表示可否 */
  showSidebar: boolean = true;
  /** サイドバー横幅 */
  sidebarWidth: string = "210px";
  /** サイドバーの上マージン（ヘッダーの高さが動的なので計算して求める） */
  sidebarMarginTop: string = "66px";
  /** 表示しているサイドメニュー */
  curerntSideMenu: "familyService" | "waiterService" | "otherOfficeService" = "familyService";

  /** ヘッダーの表示行数 */
  headerLineCount: number = 1;
  /** ヘッダーの現在年月日の表示可否 */
  showToday: boolean = true;
  /** ヘッダー表示用の現在年月日 */
  today: any = {
    year: "",
    month: "",
    date: ""
  };

  /** 未配布の写真数 */
  nonDistributedCount: number | string = 0;
  /** 未確認の受信メッセージ数 */
  nonFinishedOpinionCount: number | string = 0;
  /** 未確認の問い合わせ数 */
  nonFinishedContactCount: number | string = 0;
  /** 未読のお知らせ数 */
  unconfirmedNotificationCount: number | string = 0;
  /** 送信メッセージの返信があるか */
  showSendMessageIncoming: boolean = false;
  /** 待機者の新規登録数 */
  beforeJudgementWaiterCount: number | string = 0;
  /** 待機者送信メッセージの返信があるか */
  showWaiterSendMessageIncoming: boolean = false;
  /** 面会予約の未承諾数 */
  unconsentedReservationCount: number | string = 0;
  /** 外出外泊届けの未承諾数 */
  unconsentedOutingCount: number | string = 0;
  /** 施設見学の受付状態「未」の数 */
  showInspectionReservationCount: number | string = 0;
  /** 入所募集問い合わせ「未」の数 */
  showRecruitmentContactCount: number | string = 0;
  /** 未確認の受信メッセージ数(待機者) */
  nonFinishedWaiterOpinionCount: number | string = 0;
  /** 他事業所連携メッセージの未読があるか */
  showSendOtherOfficeMessageIncoming: boolean = false;
  /** 他事業所連携リクエストの未返信数 */
  noreplyOtherOfficeAcceptanceRequestCount: number | string = 0;

  /** templateで使用するので、importしたUrlクラスをdataとして保持する */
  urls: {} = PcUrl;

  /** 未読お知らせ */
  unReadNotifications: Array<UnReadNotificationTableItem> = [];
  /** 未読お知らせモーダル表示可否 */
  showUnReadNotificationsModal: boolean = false;

  /**
   * keep-aliveでキャッシュするコンポーネント名
   * keep-aliveを指定しても親コンポーネントのインスタンスがdestroyするとキャッシュ対象の子コンポーネントもdestroyする
   * そのため画面コンポーネントをキャッシュ対象する
   *
   * sta、prod環境はビルド時に難読化が行われるのでclass名が定義したものと異なる名前になってしまう
   * キャッシュ対象のコンポーネントは `@Component( name: "FamilyList" })` のように、コンポーネント名を指定する必要がある
   *
   * vee-validatorもキャッシュしてしまうため、キャッシュ対象のコンポーネントで
   * $_veeValidate: { validator: "new" }しているものはdeactivated()のタイミングでvalidatorをリセットする必要があるので注意
   */
  cacheTargetComponentNames: string[] = [
    "SendMessage",
    "WaiterList",
    "SendWaiterMessage",
    "ResidentList",
    "FamilyList",
    "OtherUserGroupList",
    "SendMessageGroupList",
    "Report",
    "EventList"
  ];

  get _facilityName(): string {
    return userStore.facility.name ? userStore.facility.name : "";
  }

  get _showFacilityChangeButton(): boolean {
    return 1 < userStore.facilities.length ? true : false;
  }

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  get _useWaiterService(): boolean {
    return userStore.facility.useWaiterService && userStore.loginUser.permissions.functions.useWaiterService;
  }

  get _useOtherOfficeService(): boolean {
    return userStore.facility.useOtherOfficeConnectionService && userStore.loginUser.permissions.functions.useOtherOfficeConnectionService;
  }

  /** ### プランがライト以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### プランがベーシック以上かを返す */
  get _isOverBasicPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### プランがベーシックかを返す */
  get _isBasicPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.BASIC == planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### プラン(待機者)がベーシック以上かを返す */
  get _isOverWaiterBasicPlan(): boolean {
    const planType: WaiterServicePlanType = userStore.facility.waiterServicePlanType;

    if (WaiterServicePlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** 権限ロールが一般ユーザーかを返す */
  get _isAdminRole(): boolean {
    if (userStore.loginUser.role != Role.STANDARD_USER) {
      return true;
    } else {
      return false;
    }
  }

  /** 権限ロールが一般ユーザーかを返す */
  get _isStandardRole(): boolean {
    if (userStore.loginUser.role == Role.STANDARD_USER) {
      return true;
    } else {
      return false;
    }
  }

  /** 権限ロールを返却する */
  get getRole(): Role {
    return userStore.loginUser.role;
  }

  get getPlanType(): PlanType {
    return userStore.facility.planType;
  }

  get _getSidebarClass(): string {
    if (this.showSidebar) {
      return "sidebar";
    } else {
      // return "sidebar hide-sidebar";
      return "sidebar hide-sidebar";
    }
  }

  get _sidebarMarginTop(): string {
    return this.sidebarMarginTop;
  }

  get _sidebarMargin(): string[] {
    if (this.showSidebar == true) {
      return ["show-sidebar-margin"];
    } else {
      return ["hide-sidebar-margin"];
    }
  }

  /**
   * ### 利用者等の管理ボタンをアクティブにするかを返す
   *
   * - b-dropdownとb-popoverを組み合わせるとvuerouterのactiveclassのCSSが上手く動かない
   * - そのため、activeclassを自前で付与するために現在のURLを見て判断する
   */
  get _isManagementActive(): boolean {
    const matched: RegExpMatchArray | null = this.$route.path.match(/resident|family-user|other-user-group|send-message-group/);
    if (matched != null) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 設定の歯車ボタンをアクティブにするかを返す
   *
   * - b-dropdownとb-popoverを組み合わせるとvuerouterのactiveclassのCSSが上手く動かない
   * - そのため、activeclassを自前で付与するために現在のURLを見て判断する
   */
  get _isSettingActive(): boolean {
    const matched: RegExpMatchArray | null = this.$route.path.match(
      /facility|room\/|plan|terminate|permitted-function|account\/standard|notification-setting|cooperation-system\/list/
    );
    if (matched != null) {
      return true;
    } else {
      return false;
    }
  }

  get _curerntSideMenu(): string {
    return this.curerntSideMenu;
  }

  get _showNotificationSetting(): boolean {
    return (this._isOverLightPlan && this._useFamilyService) || (this._useOtherOfficeService && this.useFunction("otherOfficeMessagesFunction"));
  }

  @Watch("windowWidth")
  public changeWindowWidth(): void {
    // ヘッダーが2行になるか、現在年月日を表示するか計算で求める
    this.updateHeaderSetting();
    this.updateSidebarSetting();
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async created(): Promise<void> {
    /**
     * ヘッダー表示用の現在年月日を作成
     */
    const toDay: Date = new Date();
    this.today.year = toDay.getFullYear();
    const month = toDay.getMonth() + 1;
    this.today.month = month.toString();
    const date = toDay.getDate();
    this.today.date = date.toString();

    // ヘッダーが2行になるか、現在年月日を表示するか計算で求める
    this.updateHeaderSetting();
    this.updateSidebarSetting();

    // バッジ表示を更新する
    await this.refreshBadge();

    return;
  }

  public updateHeaderSetting(): void {
    if (this.windowWidth <= 600) {
      this.showToday = false;
    } else {
      this.showToday = true;
    }
    return;
  }

  public updateSidebarSetting(): void {
    this.$nextTick(() => {
      if (this.header && this.header.$el) {
        const clientHeight: number = this.header.$el.clientHeight ? this.header.$el.clientHeight : 60;
        this.sidebarMarginTop = `${Number(clientHeight + 6)}px`;
      }
    });
    return;
  }

  /**
   * ### サイドメニューの切替えを表示するか否か
   *
   * - 2つ以上のサービスが有効であれば切替えを表示する
   */
  get _showToggleSideMenu(): boolean {
    let useServiceCount = 0;
    if (this._useFamilyService) {
      useServiceCount++;
    }
    if (this._useWaiterService) {
      useServiceCount++;
    }
    if (this._useOtherOfficeService) {
      useServiceCount++;
    }
    return 1 < useServiceCount ? true : false;
  }

  /**
   * ### サイドメニューを切り替える
   *
   * - アニメーションの動作が1msあるため、表示が重ならないようにしている
   *   - 現在表示しているサービスを非表示
   *   - 1ms待機
   *   - 非表示にしていたサービスを表示
   */
  public async toggleSideMenu(): Promise<void> {
    switch (this._curerntSideMenu) {
      case "familyService": {
        // 待機者サービスが使用できるなら待機者サービスのサイドメニューを表示
        if (this._useWaiterService == true) {
          this.curerntSideMenu = "waiterService";
        }
        // 他事業所連携サービスが使用できるなら他事業所連携サービスのサイドメニューを表示
        else if (this._useOtherOfficeService == true) {
          this.curerntSideMenu = "otherOfficeService";
        }
        break;
      }
      case "waiterService": {
        // 他事業所連携サービスが使用できるなら他事業所連携サービスのサイドメニューを表示
        if (this._useOtherOfficeService == true) {
          this.curerntSideMenu = "otherOfficeService";
        }
        // 家族連絡サービスが使用できるなら家族連絡サービスのサイドメニューを表示
        else if (this._useFamilyService == true) {
          this.curerntSideMenu = "familyService";
        }
        break;
      }
      case "otherOfficeService": {
        // 家族連絡サービスが使用できるなら家族連絡サービスのサイドメニューを表示
        if (this._useFamilyService == true) {
          this.curerntSideMenu = "familyService";
        }
        // 待機者サービスが使用できるなら待機者サービスのサイドメニューを表示
        else if (this._useWaiterService == true) {
          this.curerntSideMenu = "waiterService";
        }
        break;
      }
    }
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  public async createView(): Promise<void> {
    // 表示対象のサイドメニューを設定する
    if (this._useFamilyService == true) {
      this.curerntSideMenu = "familyService";
    } else if (this._useWaiterService == true) {
      this.curerntSideMenu = "waiterService";
    } else if (this._useOtherOfficeService == true) {
      this.curerntSideMenu = "otherOfficeService";
    }

    // コンテンツエリアの表示対象を決める
    // 基本的には現在のRoute値へ遷移するが、本画面(PcUrl.Dashboard)の場合はホーム画面を表示する
    if (this.$route.path == PcUrl.Dashboard) {
      // 家族連絡サービスが使用可能であればホーム画面へ遷移する
      if (userStore.facility.useFamilyService == true) {
        this.$router.push(PcUrl.HomeForFamilies);
      }
      // 家族連絡サービスが使用不可かつ、入所者募集・待機者管理サービスが使用可能であれば待機者ホーム画面
      else if (userStore.facility.useWaiterService == true) {
        this.$router.push(PcUrl.HomeForWaiters);
      }
      // 家族連絡サービスが使用不可かつ、入所者募集・待機者管理サービスが使用不可かつ、他事業所連携サービスが使用かのうであれば他事業所ホーム画面
      else if (userStore.facility.useOtherOfficeConnectionService == true) {
        this.$router.push(PcUrl.HomeForOtherOffice);
      }
      // 全サービスが使用不可であれば404画面
      else {
        this.$router.push(Url.NotFound);
      }
    } else {
      // #Topic:
      // vue-router現在のルート位置を覚えているので、this.$routeを使えば必要な情報は取得できる
      this.$router.push({ name: this.$route.name, params: this.$route.params });
    }

    /**
     * 家族連絡サービス契約している場合、以下を実施する
     *
     * - フリープランなら広告モーダル
     *   - 広告モーダルを閉じた後にリマインドは実施される
     * - フリープラン以外ならリマインド
     *   - リマインドを閉じた後に解約依頼中通知モーダルは実施される
     * - リマインドしない場合、解約依頼中通知
     * - 未読お知らせの通知
     */
    if (this._useFamilyService) {
      if (userStore.facility.planType == PlanType.FREE) {
        this.showAdModal = true;
      }
      userStore.updateShowedPaidPlanAds(true);

      if (userStore.facility.planType != PlanType.FREE) {
        await this.closeAdModal();
      }

      const notifications: Array<NotificationsGetModel> = await this.getNotifications();
      let unReadNotifications: Array<UnReadNotificationTableItem> = [];
      for (const notification of notifications) {
        if (this.isUnread(notification)) {
          unReadNotifications.push({
            id: notification.id,
            text: notification.text,
            deleteFlag: notification.deleteFlag,
            startPublish: notification.startPublish,
            endPublish: notification.endPublish,
            created: notification.created,
            updated: notification.updated,
            date: this.$dateUtil.convertNumberToString(notification.startPublish, "yyyy年mm月dd日"),
            title: notification.title,
            required: this.isUnread(notification)
          });
        }
      }

      this.unReadNotifications = unReadNotifications;
      if (0 < unReadNotifications.length && userStore.unreadNotificationsReminded == false) {
        this.showUnReadNotificationsModal = true;
        userStore.updateUnreadNotificationsReminded(true);
      }
    }

    // 解約依頼中かつ、各リマインドモーダルを表示していない場合は解約処理中モーダルを表示する
    if (userStore.reservationsReminded == false || this.showRemindReservatoinModal == false) {
      this.closeRemindReservatoinModal();
    }

    return;
  }

  public showFacilitySelectModal(): void {
    const facilityOptions: Array<{ value: number | string; label: string }> = [];
    for (const facility of userStore.facilities) {
      if (userStore.loginUser.facilityId != facility.id) {
        facilityOptions.push({
          value: facility.id,
          label: facility.name
        });
      }
    }
    this.facilityOptions = facilityOptions;
    this.showFacilitySelect = true;
    return;
  }

  /**
   * ### 施設にログインする
   */
  public async onLoginByFacility(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "施設を切替えています...";

    try {
      /**
       * 別施設にログインする
       *
       * - 現在の施設では表示可能な画面でも、切替え後の施設では表示不可な場合がある（切替え前は家族サービスが使えるが、切替え後は使えない等）
       * - 施設が表示できないページだと404エラーになってしまうので一旦共通ページへ遷移した後に別施設にログインする
       * - 別施設にログイン後、サービスの使用可否を見て利用可能なサービスのトップページへ遷移する
       * - keep-aliveのキャッシュをクリアするためにコンテンツ領域を一度消し、再描画する
       */
      const loginByFacilityResponse: LoginByFacilityResponse = await this.loginByFacility(this.selectFacilityId as number);
      userStore.login({ loginByFacilityResponse, facilities: userStore.facilities, password: userStore.password });

      /**
       * storeを初期化する
       *
       * - 別施設にログインしなおすのでstoreを初期化して現在の施設の情報が表示されないようにする
       */
      itemListFilterStore.initializeState();
      screenInputTemporaryStore.initializeScreenInputTemporary();
      tabIndexesStore.initializeTabIndex();
      editAccountStore.setUserId({ userId: "" }); // 一般ユーザー権限編集画面で施設を切り替えると、切り替え直後に一般ユーザー情報を取得しにいってしまうためuserIdを空にする

      // 非同期処理で画面遷移して、後続処理は必ず画面遷移後で実施するようにする
      await this.gotoServiceTopPage();

      this.showContent = false;
      this.$nextTick(async () => {
        await this.createView();
        await this.refreshBadge(); // バッジを更新する
        this.selectFacilityId = null;

        this.showContent = true;
      });
    } catch (error) {
      this.loginErrorHandle(error as AxiosError);
    } finally {
      this.isBusy = false;
    }

    return;
  }

  /** ### ログイン時のエラーをハンドリングする */
  public loginErrorHandle(error: AxiosError): void {
    console.debug("loginErrorHandle axiosError:", error);
    if (error.response) {
      // メンテナンス中の場合、メンテナンス画面へ遷移する
      if (error.response.status == 503) {
        this.$router.push(Url.Maintenance);
      }
      // 403エラーかつ、メッセージがIPアドレス制限の場合、メッセージを分ける
      else if (error.response.status == 403 && (error.response.data as { message: string }).message == "IP address not allowed.") {
        this.loginErrorMessage = "許可されていないIPアドレスのため、ログインできません";
        this.showLoginErrorModal = true;

        // 施設選択をリセットする
        this.selectFacilityId = null;
        this.facilityOptions = [];
      }
    } else {
      this.loginErrorMessage = "ログインに失敗しました";
      alert("キーボードのF5ボタンもしくはブラウザの更新ボタンでページを更新してお試しください。");
    }
    return;
  }

  /**
   * ### 現在のサービス使用可否に応じたトップページへ遷移する
   *
   * - push()にcallbackを渡して画面遷移を非同期処理で待てるようにする
   */
  private gotoServiceTopPage(): Promise<void> {
    return new Promise((resolve) => {
      const callback = () => resolve();

      // 家族連絡サービスが使用可能であればホーム画面へ遷移する
      if (userStore.facility.useFamilyService == true) {
        this.$router.push(PcUrl.HomeForFamilies, callback, callback);
      }
      // それ以外で入所者募集・待機者管理サービスが使用可能であれば待機者一覧
      else if (userStore.facility.useWaiterService == true) {
        this.$router.push(PcUrl.HomeForWaiters, callback, callback);
      }
      // それ以外で他事業所連携サービスが使用可能であれば他事業所連携トップ
      else if (userStore.facility.useOtherOfficeConnectionService == true) {
        this.$router.push(PcUrl.HomeForOtherOffice, callback, callback);
      }
      // 全サービスが使用不可の場合は404画面
      else {
        this.$router.push(Url.NotFound, callback, callback);
      }
    });
  }

  /**
   * ### 施設ログイン処理
   *
   * IDとパスワード、施設IDでログイン認証する
   */
  public async loginByFacility(facilityId: number): Promise<LoginByFacilityResponse> {
    const params: LoginByFacilityPostModel = {
      userId: userStore.loginUser.userId,
      password: userStore.password,
      facilityId: facilityId
    };
    const response = await this.authorizationService.loginByFacility(params);
    return response;
  }

  /**
   * ### お知らせを取得する
   */
  public async getNotifications(): Promise<Array<NotificationsGetModel>> {
    const response: Array<NotificationsGetModel> = await this.notificationsService.get(userStore);
    return response;
  }

  /**
   * ### お知らせが未読かどうかを返す
   */
  public isUnread(notification: NotificationsGetModel): boolean {
    // 確認必須か
    if (!notification.required) {
      return false;
    }

    // ログイン時に取得した既読お知らせリストと照合し、未読か照合する
    if (0 <= userStore.loginUser.confirmedNotificationIds.indexOf(notification.id)) {
      return false;
    }

    return true;
  }

  /**
   * ### 広告モーダルの閉じるイベント
   *
   * - リマインドが未実施であればリマインドを実施する
   * - リマインドのローディングを表示する
   * - リマインド対象の面会予約を取得する
   * - 1件でもあればモーダルを表示する
   * - リマインドを表示したらstoreに保持しているリマインド済みかどうかをtrueにする
   * - リマインドのローディングを非表示にする
   */
  public async closeAdModal(): Promise<void> {
    if (userStore.reservationsReminded == false) {
      this.remindReservationIsLoading = true;

      // 列名の表示可否を判断するために設定は最初に取得する
      const visitSetting: ReservationSettingsGetModel = await this.getReservationSetting();
      this.visitSetting = visitSetting;
      const onlineSetting: OnlineReservationSettingsGetModel = await this.getOnlineReservationSetting();
      this.onlineSetting = onlineSetting;

      const reservations: Array<ReservationsGetModel> = await this.getRemindReservations();
      this.remindReservation = reservations;

      if (0 < reservations.length) {
        this.showRemindReservatoinModal = true;
      } else {
        await this.closeRemindReservatoinModal();
      }

      userStore.updateReservationsReminded(true);
      this.remindReservationIsLoading = false;
    }
    return;
  }

  /**
   * ### 訪問面会設定を取得する
   */
  public async getReservationSetting(): Promise<ReservationSettingsGetModel> {
    const response: ReservationSettingsGetModel = await this.reservationSettingsService.get(userStore);
    return response;
  }

  /**
   * ### オンライン面会設定を取得する
   */
  public async getOnlineReservationSetting(): Promise<OnlineReservationSettingsGetModel> {
    const response: OnlineReservationSettingsGetModel = await this.onlineReservationSettingsService.get(userStore);
    return response;
  }

  /**
   * ### リマインド対象の面会予約を取得する
   *
   * - リマインド対象の今日の面会予約を取得する
   */
  public async getRemindReservations(): Promise<Array<ReservationsGetModel>> {
    // 引数で使用する現在日を作成する
    const today: Date = new Date();
    const year: string = this.$dateUtil.convertDateToString(today, "yyyy");
    const month: string = this.$dateUtil.convertDateToString(today, "mm");
    const date: string = this.$dateUtil.convertDateToString(today, "dd");

    // 機能使用可否が面会予約(訪問)、面会予約(オンライン)の両方がfalseの場合はリマインダーを非表示にしたいのでそのままreturnする
    const permittedFunctions: PermittedFunctions = userStore.facility.permittedFunctions;
    if (permittedFunctions.reservation == false && permittedFunctions.onlineReservation == false) {
      return [];
    }

    const reservations: Array<ReservationsGetModel> = await this.reservationsService.getRemind(userStore, year, month, date);

    return reservations;
  }

  /**
   * ### 面会予約リマインドモーダルの閉じるイベント
   *
   * - ライトプラン以上なら外出外泊届けリマインドモーダルを表示する
   * - それ以外の場合、解約依頼中なら解約依頼中モーダルを表示する
   */
  public async closeRemindReservatoinModal(): Promise<void> {
    if (this._isOverLightPlan) {
      if (userStore.outingsReminded == false) {
        this.remindOutingIsLoading = true;

        const outings: Array<OutingGetModel> = await this.getRemindOutings();
        this.remindOuting = outings;

        if (0 < outings.length) {
          this.showRemindOutingModal = true;
        }

        userStore.updateReservationsReminded(true);
        this.remindOutingIsLoading = false;
      }
    } else {
      if (userStore.facility.validPeriodTo) {
        this.showNotificationTerminateModal = true;
      } else {
        this.showNotificationTerminateModal = false;
      }
    }
    return;
  }

  /**
   * ### リマインド対象の外出外泊届けを取得する
   *
   * - リマインド対象の今日の外出外泊届けを取得する
   */
  public async getRemindOutings(): Promise<Array<OutingGetModel>> {
    // 機能使用可否がfalseの場合はリマインダーを非表示にしたいのでそのままreturnする
    const permittedFunctions: PermittedFunctions = userStore.facility.permittedFunctions;
    if (permittedFunctions.outing == false) {
      return [];
    }
    const today = new Date();
    const start: number = this.$dateUtil.convertDateToNumber(today, "yyyymmdd000000000");
    const end: number = this.$dateUtil.convertDateToNumber(today, "yyyymmdd235900000");

    const outings: Array<OutingGetModel> = await this.outingsService.gets(userStore, {
      start,
      end
    });

    return outings;
  }

  /**
   * ### 面会予約リマインドをPDF出力＆ダウンロードさせる
   */
  public async printRemindReservations(showCanceled: boolean): Promise<void> {
    // キャンセル済を表示するか否かでフィルタリングする
    const showTargetReservations: Array<ReservationsGetModel> = this.remindReservation.filter((reservation) => {
      // 削除済を表示する場合、全レコードを表示させる
      if (showCanceled == true) {
        return true;
      }
      // 削除済を表示しない場合、削除されていないレコードのみを表示させる
      else {
        if (reservation.deleteFlag == false) {
          return true;
        } else {
          return false;
        }
      }
    });

    const fileName: string = this.createRemindReservationsPdfFileName();
    const font: string = await fontsStore.getPdfFont({ userStore });
    const remindReservationsPdf: RemindReservationsPdfUtil = new RemindReservationsPdfUtil(font, userStore.facility, this.visitSetting!, this.onlineSetting!);
    await remindReservationsPdf.createAndDownloadPdf(showTargetReservations, userStore.facility.name, fileName);
    return;
  }

  /**
   * ### 面会予約リマインドPDFファイル名を作成する
   */
  public createRemindReservationsPdfFileName(): string {
    return `HitomeQコネクト-本日の面会予約一覧.pdf`;
  }

  /**
   * ### 外出外泊届けリマインドモーダルの閉じるイベント
   *
   * - 解約依頼中モーダルを表示する
   */
  public async closeRemindOutingModal(): Promise<void> {
    userStore.updateOutingsReminded(true);
    if (userStore.facility.validPeriodTo) {
      this.showNotificationTerminateModal = true;
    } else {
      this.showNotificationTerminateModal = false;
    }
    return;
  }

  /**
   * ### 外出外泊届けリマインドをPDF出力＆ダウンロードさせる
   */
  public async printRemindOutings(showCanceled: boolean): Promise<void> {
    // キャンセル済を表示するか否かでフィルタリングする
    const showTargetOutings: Array<OutingGetModel> = this.remindOuting.filter((outing) => {
      // 削除済を表示する場合、全レコードを表示させる
      if (showCanceled == true) {
        return true;
      }
      // 削除済を表示しない場合、削除されていないレコードのみを表示させる
      else {
        if (outing.deleteFlag == false) {
          return true;
        } else {
          return false;
        }
      }
    });

    const fileName: string = this.createRemindOutingsPdfFileName();
    const font: string = await fontsStore.getPdfFont({ userStore });
    const remindOutingsPdf: RemindOutingsPdfUtil = new RemindOutingsPdfUtil(font);
    await remindOutingsPdf.createAndDownloadPdf(showTargetOutings, userStore.facility.name, fileName);
    return;
  }

  /**
   * ### 面会予約リマインドPDFファイル名を作成する
   */
  public createRemindOutingsPdfFileName(): string {
    return `HitomeQコネクト-本日の外出外泊届け一覧.pdf`;
  }

  /**
   * ### ログアウトモーダルを表示する
   */
  public conformLogout(): void {
    const logoutModal: LogoutModal | Vue | Element | Vue[] | Element[] = this.$refs.logout;
    if (logoutModal instanceof LogoutModal) {
      logoutModal.show();
    }
    return;
  }

  /**
   * ### バッジ数を更新する
   *
   * - バッジ数ではないが、解約依頼中かどうかもここで取得している
   * - バッジの更新でシステムエラーにはしないため、コンソールエラーだけにする
   * - 取得対象は以下(家族連絡サービス)
   *   - 未配布写真数
   *   - 未確認受信メッセージ
   *   - 未確認お問い合わせ数
   *   - 未読のお知らせ数
   *   - 家族連絡サービスの解約依頼がされているか
   *   - メッセージ送信の返信未読があるか
   *   - 面会予約の未承諾があるか
   * - 取得対象は以下(待機者管理サービス)
   *   - 待機者の新規登録者数
   *   - 待機者メッセージ送信の返信未読があるか
   *   - 施設見学予約の受付状態「未」の数
   *   - 入所募集問い合わせの対応状態「未」の数
   *   - 未確認受信メッセージ
   */
  public async refreshBadge(): Promise<void> {
    await tabIndexesStore.initializeTabIndex();

    if (this._useFamilyService) {
      Promise.all([
        this.updateNonDistributedCount(),
        this.updateNonFinishedOpinionCount(),
        this.updateNonFinishedContactCount(),
        this.updateUnconfirmedNotificationCount(),
        this.updateShowSendMessageIncoming(),
        this.updateUnconsentedReservationCount(),
        this.updateUnconsentedOutingCount()
      ]).then((results: Array<any>) => {
        for (const result of results) {
          if (result instanceof SystemError) {
            console.error("error:", result);
          }
        }
      });
    }

    if (this._useWaiterService) {
      Promise.all([
        this.updateBeforeJudgementWaiterCount(),
        this.updateShowWaiterSendMessageIncoming(),
        this.updateInspectionReservationCount(),
        this.updateRecruitmentContactCount(),
        this.updateNonFinishedWaiterOpinionCount()
      ]).then((results: Array<any>) => {
        for (const result of results) {
          if (result instanceof SystemError) {
            console.error("error:", result);
          }
        }
      });
    }

    if (this._useOtherOfficeService) {
      Promise.all([this.updatenoreplyOtherOfficeAcceptanceRequestCount()]).then((results: Array<any>) => {
        for (const result of results) {
          if (result instanceof SystemError) {
            console.error("error:", result);
          }
        }
      });
    }

    return;
  }

  /**
   * ### 未配布写真数を更新する
   */
  public async updateNonDistributedCount(): Promise<void | SystemError> {
    try {
      // プランによっては写真印刷依頼の機能を制限するので、その場合は0件として扱う
      if (PlanType.BASIC <= this.getPlanType) {
        const params: any = { distributed: false };
        const count: number = await this.picturesService.getCount(userStore, params);

        // 100件以上の場合は!を格納する
        if (100 <= count) {
          this.nonDistributedCount = "!";
        } else {
          this.nonDistributedCount = count;
        }
      } else {
        this.nonDistributedCount = 0;
      }
    } catch (error) {
      // 配布していない写真数が取得できない場合は0を格納して非表示にする
      this.nonDistributedCount = 0;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 未確認からの受信メッセージ数を更新する
   */
  public async updateNonFinishedOpinionCount(): Promise<void | SystemError> {
    try {
      // 家族からの連絡機能が使用不可の場合は家族からの受信メッセージは0件として扱う
      let familyCount: number = 0;
      if (this.showMenuOfPermitted("opinion")) {
        familyCount = await this.opinionsService.getCount(userStore, { confirmed: false });
      }

      // プランによっては施設関係者の機能を制限するので、その場合は未読無しとして扱う
      if (PlanType.BASIC <= this.getPlanType) {
        const otheruserCount: number = await this.otherUserOpinionService.getCount(userStore, { confirmed: false });

        // 100件以上の場合は!を格納する
        if (100 <= familyCount + otheruserCount) {
          this.nonFinishedOpinionCount = "!";
        } else {
          this.nonFinishedOpinionCount = familyCount + otheruserCount;
        }
      } else {
        // 100件以上の場合は!を格納する
        if (100 <= familyCount) {
          this.nonFinishedOpinionCount = "!";
        } else {
          this.nonFinishedOpinionCount = familyCount;
        }
      }
    } catch (error) {
      // 機能使用不可でステータスコード405が返却された場合はエラーとして扱わない
      const systemError: SystemError = error as SystemError;
      this.nonFinishedOpinionCount = 0;
      if (systemError.statusCode == 405) {
        return undefined;
      } else {
        // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
        return error as SystemError;
      }
    }

    return;
  }

  /**
   * ### 未確認お問い合わせ数を更新する
   */
  public async updateNonFinishedContactCount(): Promise<void | SystemError> {
    try {
      const params: any = {
        confirmed: false
      };
      const count: number = await this.contactsService.getCount(userStore, HitomeqErrorType.IGNORE, params);

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.nonFinishedContactCount = "!";
      } else {
        this.nonFinishedContactCount = count;
      }
    } catch (error) {
      // 配布していない問い合わせが取得できない場合は0を格納して非表示にする
      this.nonFinishedContactCount = 0;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 未読のお知らせ数を更新する
   */
  public async updateUnconfirmedNotificationCount(): Promise<void | SystemError> {
    try {
      const count: number = await this.notificationsService.getUnconfirmedNotificationCount(userStore, { userId: userStore.loginUser.userId });

      // このタイミングで保持しているユーザー情報の「既読のお知らせ」も更新する
      const user: any = await this.accountsService.post(userStore);
      userStore.updateLoginUser({ loginUser: user });

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.unconfirmedNotificationCount = "!";
      } else {
        this.unconfirmedNotificationCount = count;
      }
    } catch (error) {
      // 配布していない問い合わせが取得できない場合は0を格納して非表示にする
      this.unconfirmedNotificationCount = 0;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### メッセージ送信の返信未読があるかを取得する
   */
  public async updateShowSendMessageIncoming(): Promise<void | SystemError> {
    try {
      const showSendMessageIncoming: SendMessageRepliesUnreadModel = await this.sendMessageRepliesService.getUnreadInFacility(userStore);

      // プランによっては施設関係者の機能を制限するので、その場合は未読無しとして扱う
      if (PlanType.BASIC <= this.getPlanType) {
        const showOtherUserGroupSendMessageIncoming: SendMessageRepliesUnreadModel = await this.otherUserGroupSendMessageRepliesService.getUnreadInFacility(userStore);

        if (showSendMessageIncoming.unread == true || showOtherUserGroupSendMessageIncoming.unread == true) {
          this.showSendMessageIncoming = true;
        } else {
          this.showSendMessageIncoming = false;
        }
      } else {
        this.showSendMessageIncoming = showSendMessageIncoming.unread;
      }
    } catch (error) {
      // 配布していない問い合わせが取得できない場合は0を格納して非表示にする
      this.showSendMessageIncoming = false;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 待機者の新規申込者の数を更新する
   */
  public async updateBeforeJudgementWaiterCount(): Promise<void | SystemError> {
    try {
      const response: Array<WaitersGetModel> = await this.waitersService.gets(userStore);

      let count: number = 0;
      for (const waiter of response) {
        switch (waiter.status) {
          case ResidentStatus.REGISTERD:
          case ResidentStatus.APPLICATION:
          case ResidentStatus.RECEIVED_APPLICATION: {
            count++;
            break;
          }
          default: {
            break;
          }
        }
      }

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.beforeJudgementWaiterCount = "!";
      } else {
        this.beforeJudgementWaiterCount = count;
      }
    } catch (error) {
      this.beforeJudgementWaiterCount = 0;
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 待機者メッセージ送信の返信未読があるかを取得する
   */
  public async updateShowWaiterSendMessageIncoming(): Promise<void | SystemError> {
    try {
      const showWaiterSendMessageIncoming: WaiterSendMessageRepliesUnreadModel = await this.waiterSendMessageRepliesService.getUnreadInFacility(userStore);

      if (showWaiterSendMessageIncoming.unread) {
        this.showWaiterSendMessageIncoming = true;
      } else {
        this.showWaiterSendMessageIncoming = false;
      }
    } catch (error) {
      // 配布していない問い合わせが取得できない場合は0を格納して非表示にする
      this.showWaiterSendMessageIncoming = false;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 面会予約の未承諾があるかを取得する
   */
  public async updateUnconsentedReservationCount(): Promise<void | SystemError> {
    // 訪問予約とオンライン面会機能が使用不可の場合は即returnする
    if (userStore.facility.permittedFunctions.reservation == false && userStore.facility.permittedFunctions.onlineReservation == false) {
      this.unconsentedReservationCount = 0;
      return;
    }

    try {
      // 過去の面会予約は表示対象外にするため、開始日時を指定する
      const start: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000");
      let params: any = {
        start: start,
        sortKey: "datetime",
        order: "asc"
      };

      const reservations: Array<ReservationsGetModel> = await this.reservationsService.gets(userStore, params);

      let count: number = 0;
      for (const reservation of reservations) {
        if (reservation.consented == false) {
          count++;
        }
      }

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.unconsentedReservationCount = "!";
      } else {
        this.unconsentedReservationCount = count;
      }
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 面会予約の未承諾があるかを取得する
   */
  public async updateUnconsentedOutingCount(): Promise<void | SystemError> {
    // 機能が使用不可の場合は即returnする
    if (userStore.facility.permittedFunctions.outing == false) {
      this.unconsentedOutingCount = 0;
      return;
    }

    try {
      // 過去の外出外泊届けは表示対象外にするため、開始日時を指定する
      const start: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000");
      const end: number = 90000101000000000; // 終了日時は17桁で扱える大きい数字を指定する
      let params: any = {
        start: start,
        end: end
      };

      const outings: Array<OutingGetModel> = await this.outingsService.gets(userStore, params);

      // 外出外泊届けはキャンセルも取得されるので、削除されていないものだけにする
      let count: number = 0;
      for (const outing of outings) {
        if (outing.consented == false && outing.deleteFlag == false) {
          count++;
        }
      }

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.unconsentedOutingCount = "!";
      } else {
        this.unconsentedOutingCount = count;
      }
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 施設見学予約の受付状態「未」の数を更新する
   */
  public async updateInspectionReservationCount(): Promise<void | SystemError> {
    try {
      const query: any = {
        start: this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000")
      };
      const response: Array<InspectionReservationsGetModel> = await this.inspectionReservationsService.gets(userStore, query);

      let count: number = 0;
      for (const record of response) {
        if (record.approved == false) {
          count++;
        }
      }

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.showInspectionReservationCount = "!";
      } else {
        this.showInspectionReservationCount = count;
      }
    } catch (error) {
      this.showInspectionReservationCount = 0;
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 入所募集問い合わせの対応状態「未」の数を更新する
   */
  public async updateRecruitmentContactCount(): Promise<void | SystemError> {
    try {
      const response: Array<RecruitmentContactsGetModel> = await this.recruitmentContactsService.gets(userStore);

      let count: number = 0;
      for (const record of response) {
        if (record.done == false) {
          count++;
        }
      }

      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.showRecruitmentContactCount = "!";
      } else {
        this.showRecruitmentContactCount = count;
      }
    } catch (error) {
      this.showRecruitmentContactCount = 0;
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 未確認の受信メッセージ数(待機者)を更新する
   */
  public async updateNonFinishedWaiterOpinionCount(): Promise<void | SystemError> {
    try {
      if (userStore.facility.permittedFunctions.waiterOpinion) {
        // 待機者家族からの連絡機能が使用不可の場合は家族からの受信メッセージは0件として扱う
        const count: number = await this.waiterOpinionsService.getCount(userStore, { confirmed: false });
        // 100件以上の場合は!を格納する
        if (100 <= count) {
          this.nonFinishedWaiterOpinionCount = "!";
        } else {
          this.nonFinishedWaiterOpinionCount = count;
        }
      }
    } catch (error) {
      // 機能使用不可でステータスコード405が返却された場合はエラーとして扱わない
      const systemError: SystemError = error as SystemError;
      this.nonFinishedWaiterOpinionCount = 0;
      if (systemError.statusCode == 405) {
        return undefined;
      } else {
        // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
        return error as SystemError;
      }
    }

    return;
  }

  /**
   * ### 他事業所連携受入リクエストで未返信のものがあるかを取得する
   */
  public async updatenoreplyOtherOfficeAcceptanceRequestCount(): Promise<void | SystemError> {
    try {
      const count: number = await this.otherOfficeAcceptanceRequestsService.existNoreply(userStore);
      // 100件以上の場合は!を格納する
      if (100 <= count) {
        this.noreplyOtherOfficeAcceptanceRequestCount = "!";
      } else {
        this.noreplyOtherOfficeAcceptanceRequestCount = count;
      }
    } catch (error) {
      this.noreplyOtherOfficeAcceptanceRequestCount = 0;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 各種設定Dropdownの表示イベントハンドラー
   *
   * - 各種設定Popoverを非表示にする
   * - 各種設定Popoverの機能を無効にする
   */
  public showManagementPopover(): void {
    const popover: any = this.$refs.managementPopover;
    popover.$emit("close");
    popover.$emit("disable");

    return;
  }

  /**
   * ### 各種設定Dropdownの非表示イベントハンドラー
   *
   * - 各種設定Popoverの機能を有効にする
   */
  public hideManagementPopover(): void {
    const popover: any = this.$refs.managementPopover;
    popover.$emit("enable");

    return;
  }

  /**
   * ### 各種設定Dropdownの表示イベントハンドラー
   *
   * - 各種設定Popoverを非表示にする
   * - 各種設定Popoverの機能を無効にする
   */
  public showSettingPopover(): void {
    const popover: any = this.$refs.settingPopover;
    popover.$emit("close");
    popover.$emit("disable");

    return;
  }

  /**
   * ### 各種設定Dropdownの非表示イベントハンドラー
   *
   * - 各種設定Popoverの機能を有効にする
   */
  public hideSettingPopover(): void {
    const popover: any = this.$refs.settingPopover;
    popover.$emit("enable");

    return;
  }

  /**
   * ### 受信メッセージの表示可否を返す
   */
  public showOpinionMessageMenu(): boolean {
    const planType: PlanType = userStore.facility.planType;

    // ベーシック以上は施設関係者の受信メッセージが必ずあるのでtrue
    if (PlanType.BASIC <= planType) {
      return true;
    }
    // フリー、ライトの場合
    else {
      // 施設が持つ「家族の使用許可機能」で「家族からの連絡」を使用していればtrueそうでなければfalse
      if (userStore.facility.permittedFunctions.opinion == true) {
        return true;
      } else {
        return false;
      }
    }
  }

  /**
   * ### メニュー表示可否を返す
   */
  public showMenuOfPermitted(functionName: string): boolean {
    // Objectのプロパティを動的参照したいが、コンパイルエラーになるのでanyにしてから取得する
    const permittedFunctions: any = userStore.facility.permittedFunctions;
    const showMenu: boolean = permittedFunctions[functionName];

    return showMenu;
  }

  /**
   * ### 一般ユーザーの機能使用可否を返す
   */
  public useFunction(key: string): boolean {
    // Objectのプロパティを動的参照したいが、コンパイルエラーになるのでanyにしてから取得する
    const functions: any = userStore.user.permissions.functions;
    const used: boolean = functions[key];

    return used;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_mixin.scss";
@import "../../styles/pc/_colors.scss";

#layout-base {
  $header-height: 66px;
  $sidebar-width: 210px;

  /** ヘッダースタイル */
  #header {
    min-height: $header-height;
    padding: 6px 16px;
    background-color: $bg-default !important;
    border-bottom: solid 6px $font-key-color;
    .hedaer-content {
      width: 100%;
    }
    .title {
      color: $font-key-color;
      font-weight: bold;
      font-size: 22px;
      margin-right: 12px;
      button {
        font-size: 22px;
        color: $font-key-color;
      }
    }
    .facility-name {
      font-size: 16px !important;
      // サイズが大きい場合省略記号にする
      max-width: 300px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .facility-change-btn {
      font-size: 12px !important;
      height: 28px !important;
      padding: 6px !important;
    }
    .today {
      color: #000;
      padding: 0 16px 0 0;
      .value {
        @include font(32px);
        margin-left: 8px;
      }
      .unit {
        @include font();
      }
    }
    .user-name {
      padding: 3px 16px 0 0;
      button {
        @include btn();
      }
    }
    .buttons {
      position: relative;
      padding: 3px 0 0 0;
      .support,
      .information {
        a {
          position: relative;

          color: $font-key-color;
          // router-linkのスタイルを上書きする
          padding: 0 16px 0 0;
          // アイコン画像の大きさを調整するために、paddingの値を調整する
          button.btn {
            padding: 4px 6px 6px 6px !important;
          }
          .information-icon {
            @include svg-icon("../../assets/header/pc/information.svg", $font-base-color);
          }
          .support-icon {
            @include svg-icon("../../assets/header/pc/support.svg", $font-base-color);
          }
        }
        // #Topic
        // template側でページ遷移はa要素ではなく、router-link要素を使用している
        // router-link要素には選択しているものにvuejsがrouter-link-activeクラスを
        // 付与するのでこれにスタイルを指定している
        a.router-link-active {
          button.btn {
            background-color: $btn-selected !important;
          }
          .information-icon {
            @include svg-icon("../../assets/header/pc/information.svg", $font-sidebar-link);
          }
          .support-icon {
            @include svg-icon("../../assets/header/pc/support.svg", $font-sidebar-link);
          }
        }
      }
      .management {
        // router-linkのスタイルを上書きする
        padding: 0 16px 0 0;

        .management-icon {
          @include svg-icon("../../assets/header/pc/management.svg", $font-base-color);
        }
        &.router-active {
          .management-icon {
            @include svg-icon("../../assets/header/pc/management.svg", $font-sidebar-link);
          }
        }
      }
      .facility {
        .setting-icon {
          @include svg-icon("../../assets/header/pc/setting.svg", $font-base-color);
        }
        &.router-active {
          .setting-icon {
            @include svg-icon("../../assets/header/pc/setting.svg", $font-sidebar-link);
          }
        }
      }
    }
    .header-badge {
      position: absolute;
      top: -18px;
      left: 18px;
      width: 32px;
      text-align: right;
      z-index: 1001;
    }
    .dropdown-item:hover {
      background-color: $list-hover;
    }
  }

  .show-sidebar-margin {
    margin-left: $sidebar-width;
  }
  .hide-sidebar-margin {
    margin-left: 50px;
  }

  /** コンテンツ */
  #content {
    position: relative;
    min-height: calc(100vh - #{$header-height});
    background-color: $bg-gray;
    padding: 10px 15px 15px 15px;

    // 親要素でpaddingを取らないとスクロール時に画面下に白余白が表示されてしまう
    // 親要素でpadingを取っているので、ここではpaddingを取らないようにする
    .main-content {
      padding: 0 !important;
    }
  }
}
// 印刷用スタイル
@media print {
  // 印刷する対象は主に<section class="content">内である
  // これに余白やサイズ制限を設けると印刷に弊害が生じるので設定をクリアする
  // 印刷するHTMLを制御したい場合は、BOOTSTRAPの.hidden-printと.visible-printを使って調整すること
  #content {
    overflow: inherit !important;
    height: 100% !important;
    padding: 0 !important;
    background-color: $bg-default !important;
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0;
  }
  .show-sidebar-margin {
    margin-left: 0 !important;
  }
}
</style>
